import { render, staticRenderFns } from "./DepartModal.vue?vue&type=template&id=23f605ab&scoped=true&"
import script from "./DepartModal.vue?vue&type=script&lang=js&"
export * from "./DepartModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "23f605ab",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/pbit/xtkf-a1/s365/env_cloud_web/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('23f605ab')) {
      api.createRecord('23f605ab', component.options)
    } else {
      api.reload('23f605ab', component.options)
    }
    module.hot.accept("./DepartModal.vue?vue&type=template&id=23f605ab&scoped=true&", function () {
      api.rerender('23f605ab', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/system/modules/DepartModal.vue"
export default component.exports